import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { corporateHealthOrderFetch, CorporateHealthOrderFetchPayload } from './action';
import { selectCorporateHealthPolicyDetails } from './selector';

export const useCorporateHealthOrderFetch = () => {
  const dispatch = useDispatch();
  const corporateHealthOrderId = Number(useRouteParam('orderableId'));
  const { corporateHealthOrder } = useSelector(selectCorporateHealthPolicyDetails);

  useEffectOnce(() => {
    if (corporateHealthOrder && corporateHealthOrder.id === corporateHealthOrderId) return;
    const payload: CorporateHealthOrderFetchPayload = { id: corporateHealthOrderId };
    dispatch(corporateHealthOrderFetch(payload));
  });

  return corporateHealthOrder;
};
